import React from 'react'
import { useSelector } from 'react-redux'

/**
 * Display or not if module is active
 * @param {React.Component} WrappedComponent
 * @param {string} moduleName
 *
 * @returns {React.Component}
 */
function withModule(WrappedComponent, moduleName) {
  function Display(props) {
    const moduleObj = useSelector((store) => store.modules[moduleName] || {})

    if (!moduleObj.isActive) return null

    return <WrappedComponent {...props} />
  }

  return Display
}

export default withModule
